import { IDefaultState } from '@modules/catalog/types/store';
import { pick } from 'lodash';

export const getCurrentFiltersFromStore = (data: Pick<IDefaultState, 'showDeleted' | 'projectID'>) => {
  return pick(data, 'projectID', 'showDeleted');
};
